
import swipebox from '@rafflex/swipebox';
export default () => {
  let galleries = document.querySelectorAll('.wp-block-gallery')

  galleries.forEach((gallery, index) => {
    let items = gallery.querySelectorAll('a')

    items.forEach(item => {
      item.setAttribute('rel', `gallery-${index}`)
    })
  })

  swipebox();
  $( '.wp-block-image a' ).swipebox();
}
